module.exports = __webpack_public_path__ + "img/faq-sticker-status.850897ed.jpg";